import { AdvancedSelect } from '@orobix/orobix-fe-components'
import { useEffect, useState } from 'react'

import { Settings } from '../types'

type SelectOption = {
  value: string
  label: string
}

interface LanguageSelectorProps {
  label?: string
  settings?: Settings
  updateSettings?: (settings: Partial<Settings>) => void
  isLoading: boolean
}

const LanguageSelector = ({
  label,
  settings,
  updateSettings,
  isLoading,
}: LanguageSelectorProps) => {
  const options = [
    { value: 'en_US', label: 'English' },
    { value: 'it_IT', label: 'Italiano' },
  ]

  const [value, setValue] = useState<SelectOption>()

  useEffect(() => {
    if (settings?.preference__user_language) {
      setValue(
        options.find(
          (option) => option.value === settings.preference__user_language
        ) as SelectOption
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [settings])

  return (
    <AdvancedSelect<SelectOption>
      value={value}
      label={label}
      name="language"
      id="language"
      options={options}
      onChange={(v: SelectOption | null) => {
        if (v && v.value !== value?.value) {
          setValue(v)
          if (updateSettings) {
            updateSettings({
              preference__user_language: v.value,
            })
          }
        }
      }}
      isDisabled={isLoading}
      isLoading={isLoading}
    />
  )
}

export default LanguageSelector
